/**
 * Formats an ISO date string ("YYYY-MM-DD") into a localized Italian short
 * label (e.g. "lun 25 dic 2025"). The noon-clamp avoids timezone rollovers.
 *
 * Shared between holidays and hours-overrides panels so we don't pull a
 * circular import via the shell. Pure function, no React.
 */
export function formatLocalDate(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T12:00:00");
  return d.toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}
